<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="driver-signup login-sec">
    <div class="driver-left-outer">
        <div class="driver-logo">
            <img src="../../assets/images/trux-blue-logo.svg" alt="" />
        </div>
        <div class="discovery-heading">
            <h2>Trux Location Gate Access</h2>
            <h5>powered by trucklots</h5>
        </div>
        <div class="mobile-imgouter">
            <img src="../../assets/images/turx-access.png" alt="" />
        </div>
    </div>
    <div class="driver-right-outer login-right">
        <form [formGroup]="truxLoginForm" (ngSubmit)="truxLogin()">
            <h3>Login</h3>
            <div class="email-outer">
                <div class="flex flex-column  bottom-space formgrid">
                    <div class="mobile-tooltip">
                        <label htmlFor="username">Username</label>
                        <app-tooltip [tooltipMessage]="mobileMsg"></app-tooltip>
                    </div>
                    <input pInputText id="username" [ngClass]="getInvalidClassFor('email')" placeholder="Enter Username"
                        aria-describedby="username-help" formControlName='email' />
                    <div
                        *ngIf="truxLoginForm.get('email')?.hasError('required') && (truxLoginForm.get('email')?.dirty || truxLoginForm.get('email')?.touched)">
                        <div class="validation-error"> This field is required*</div>
                    </div>
                    <div
                        *ngIf="truxLoginForm.get('email')?.hasError('invalidEmail') && (truxLoginForm.get('email')?.dirty || truxLoginForm.get('email')?.touched)">
                        <div class="validation-error"> Please enter a valid email*</div>
                    </div>
                    <div
                        *ngIf="truxLoginForm.get('email')?.hasError('invalidPhone') && (truxLoginForm.get('email')?.dirty || truxLoginForm.get('email')?.touched)">
                        <div class="validation-error"> Please enter a valid mobile number*</div>
                    </div>

                </div>
               <div class="flex flex-column formgrid">
                    <label htmlFor="password">Password</label>
                    <p-password class="pass-input" [ngClass]="getInvalidClassFor('password')"
                        placeholder="Enter Password" [feedback]=false indicator="false" [toggleMask]="true"
                        formControlName='password'></p-password>
                    <div
                        *ngIf="truxLoginForm.get('password')?.hasError('required') && (truxLoginForm.get('password')?.dirty || truxLoginForm.get('password')?.touched)">
                        <div class="validation-error"> This field is required*</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-column gap-2">
                <p-button type="submit" label="Log In" class="w-100"></p-button>
            </div>
        </form>
    </div>
</div>